import { Fragment } from 'react'
import { FC, c } from 'lib/component-utils'
import { Transition } from '@headlessui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/outline'
import Tooltip from 'components/base/Tooltip'

type Props = {
  label?: JSX.Element | string
  helpText?: string
  error?: string
  innerClassName?: string
  disabled?: boolean
  labelPosition?: 'top' | 'left'
}

const FormItem: FC<Props> = ({
  label,
  helpText,
  error,
  className,
  children,
  innerClassName,
  disabled,
  labelPosition = 'top',
}) => {
  const labelOnLeft = labelPosition === 'left'

  return (
    <div className={c`flex flex-col space-y-2 ${className}`}>
      <div
        className={c`${labelOnLeft} flex flex-row items-center space-x-3 | flex flex-col space-y-1 ${
          disabled ? 'opacity-50' : ''
        }`}
      >
        {label && (
          <span
            className={c`flex items-center text-sm font-medium text-black ${
              labelOnLeft
            } shrink-0 | w-full`}
          >
            <span>{label}</span>
            {helpText && (
              <Tooltip sizing="text" content={helpText}>
                <QuestionMarkCircleIcon className="w-4 h-4 ml-1 text-gray-400" />
              </Tooltip>
            )}
          </span>
        )}
        <div className={c`${labelOnLeft} min-w-0 ${innerClassName}`}>{children}</div>
      </div>
      <Transition
        show={error ? error.length > 0 : false}
        as={Fragment}
        enter="transform ease-in-out duration-300 transition"
        enterFrom="-translate-y-2 opacity-0"
        enterTo="translate-y-0 opacity-100"
        leave="transition ease-in duration-100 transition"
        leaveFrom="translate-y-0 opacity-100"
        leaveTo="-translate-y-2 opacity-0"
      >
        <p className="w-full whitespace-pre-line text-sm text-red-600">{error}</p>
      </Transition>
    </div>
  )
}

export default FormItem
